import type { Status } from '../types';

/** Цвет несёт категория статуса, а не название: названия тенант меняет как хочет. */
export function StatusBadge({ status }: { status?: Status }) {
  if (!status) return <span className="badge badge-gray">—</span>;
  return <span className={`badge ${BADGE[status.category]}`}>{status.name}</span>;
}

const BADGE: Record<Status['category'], string> = {
  TODO: 'badge-gray',
  IN_PROGRESS: 'badge-blue',
  DONE: 'badge-green',
};
